module.exports = __webpack_public_path__ + "static/media/bg-login.65c49583.jpg";